import s from "./TourHero.module.scss";
import {
  DurationIcon,
  StartTimeIcon,
  PeopleIcon,
} from "../TourIcons/TourIcons";

const TourHero = ({ data }) => {
  if (!data) return null;

  const heroImage = data.heroImage || data.images?.[0];

  return (
    <section
      className={s.root}
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      <div className={`${s.overlay} ${data.disableHeroOverlay ? s.noOverlay : ""}`}></div>

      <div className={s.content}>
        <div className={s.topBar}>
          <a href="/" className={s.backLink}>
            <svg viewBox="0 0 24 24">
              <path d="M19 12H5" />
              <path d="M12 19l-7-7 7-7" />
            </svg>
            Homeに戻る
          </a>
        </div>

        <div className={s.heroMain}>
          <div className={s.heroCopy}>
            <h1>{data.heroTitle || data.pathTitle || data.title}</h1>

            <div className={s.meta}>
              {data.time && (
                <>
                  <div className={s.metaItem}>
                    <DurationIcon />
                    <span>{data.time}</span>
                  </div>
                  <span className={s.divider}>|</span>
                </>
              )}

              {data.startTimes && (
                <>
                  <div className={s.metaItem}>
                    <StartTimeIcon />
                    <span>{data.startTimes.join(" / ")}</span>
                  </div>
                  <span className={s.divider}>|</span>
                </>
              )}

              {data.people && (
                <div className={s.metaItem}>
                  <PeopleIcon />
                  <span>{data.people}</span>
                </div>
              )}
            </div>

            {data.heroDescription && (
              <p className={s.description}>{data.heroDescription}</p>
            )}

            {data.heroPrice && (
              <div className={s.priceLine}>
                <span>PRICE</span>
                <strong>{data.heroPrice}</strong>
                {data.heroPriceNote && <small>{data.heroPriceNote}</small>}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={s.wave}>
        <svg viewBox="0 0 2880 180" preserveAspectRatio="none">
          <path d="M0,70 C320,240 560,-40 820,105 C1080,220 1260,5 1440,90 C1760,240 2000,-40 2260,105 C2520,220 2700,5 2880,90 L2880,180 L0,180 Z" />
        </svg>
      </div>
    </section>
  );
};

export default TourHero;
